// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fd55a690","952":"10cb29de"}[chunkId] + ".chunk.js";
};